export const DATE_RANGES = [
  { value: "all", label: "All Dates" },
  { value: "daily", label: "Today" },
  { value: "next7", label: "Next 7 days" },
  { value: "last7", label: "Last 7 days" },
  { value: "month", label: "This Month" },

];


export const DATE_BY_STATUS = [
  { value: "all", label: "All" },
  { value: "daily", label: "Today" },
  { value: "month", label: "Month" },
  { value: "last7", label: "PreviousWeek" },
  { value: "next7", label: "NextWeek" },
];
